export const PROFILES_SHARED={
   PAGE_NAME: 'Profiles Shared',
   BUTTON_LABELS:{
    VIEW_AVAILABILITY:'View Availability',
    REQUEST_MORE_INFO:'Request More Info',
    PROJECT_DETAILS:'Project Details',
    ADD_EXPERT:'Add Expert',
   }
}